import { initializeApp } from "firebase/app";
import {
 getMessaging,
 isSupported,
 getToken,
 onMessage,
} from "firebase/messaging";
import { GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
import { vapid_key } from "../constants/index";

const firebaseConfig = {
 apiKey: "AIzaSyBPZ918kzcCIx9ryzJlfxILj9VpbbkyRM4",
 authDomain: "send-f129e.firebaseapp.com",
 projectId: "send-f129e",
 storageBucket: "send-f129e.firebasestorage.app",
 messagingSenderId: "1044519918961",
 appId: "1:1044519918961:web:1cd35c3f86517757e62ad0",
 measurementId: "G-DDE9FG2ENN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const google = new GoogleAuthProvider();
export const facebook = new FacebookAuthProvider();

// Only init messaging if supported (HTTPS or localhost)
let messagingInstance: ReturnType<typeof getMessaging> | null = null;

(async () => {
 if (await isSupported()) {
   messagingInstance = getMessaging(app);
 } else {
   console.warn(
     "Firebase Messaging not supported in this environment (needs HTTPS or localhost)."
   );
 }
})();

export const messaging = messagingInstance;

// Request permission function
// Request permission function
export const requestNotificationPermission = async (): Promise<
 string | null
> => {
 try {
   if (!messagingInstance) return null; // prevent crash
   const permission = await Notification.requestPermission();
   if (permission === "granted") {
     const token = await getToken(messagingInstance, {
       vapidKey: vapid_key,
     });
     return token;
   }
   return null;
 } catch (error) {
   return null;
 }
};

// Handle foreground messages
// Handle foreground messages
export const onMessageListener = () => {
 return new Promise((resolve) => {
   if (!messagingInstance) return; // prevent crash
   onMessage(messagingInstance, (payload) => {
     resolve(payload);
   });
 });
};

